var _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_9781)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5183,
    cy: 39.5781,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_9781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5178 3C28.0881 3 35.0356 9.94756 35.0356 18.5178C35.0356 25.0889 30.9513 30.7061 25.1828 32.9691L20.4017 39.5043C20.302 39.6411 20.1696 39.7528 20.0158 39.8298C19.862 39.9069 19.6912 39.9472 19.5178 39.9472C19.3445 39.9472 19.1736 39.9069 19.0198 39.8298C18.866 39.7528 18.7336 39.6411 18.634 39.5043L13.8528 32.9691C8.08433 30.7061 4 25.0889 4 18.5178C4 9.94756 10.9476 3 19.5178 3Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 18.562C32.1241 11.6242 26.4999 6 19.562 6C12.6242 6 7 11.6242 7 18.562C7 25.4999 12.6242 31.1241 19.562 31.1241C26.4999 31.1241 32.1241 25.4999 32.1241 18.562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6086 19.7607V22.1519H22.3908V19.7607H27.9701V25.34C27.9701 25.7802 27.6132 26.137 27.173 26.137H12.8263C12.3861 26.137 12.0293 25.7802 12.0293 25.34V19.7607H17.6086ZM19.2026 18.1667H20.7967V20.5578H19.2026V18.1667ZM16.0145 13.3844V10.9933C16.0145 10.5531 16.3713 10.1963 16.8115 10.1963H23.1878C23.628 10.1963 23.9849 10.5531 23.9849 10.9933V13.3844H27.173C27.6132 13.3844 27.9701 13.7413 27.9701 14.1815V18.1667H22.3908V16.5726H17.6086V18.1667H12.0293V14.1815C12.0293 13.7413 12.3861 13.3844 12.8263 13.3844H16.0145ZM17.6086 11.7904V13.3844H22.3908V11.7904H17.6086Z",
    fill: "#E91E63"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_9781",
    x: 12.8678,
    y: 36.2528,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1989_9781"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_9781",
    x: 0.305226,
    y: 0.0441809,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_9781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_9781",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessMapIcon);
export default __webpack_public_path__ + "static/media/businessMapIcon.3ee3d16ccd349dc1c1e9ff2bfc050f8e.svg";
export { ForwardRef as ReactComponent };